import * as React from 'react';
import styled, { StyledProps } from 'styled-components';
import {
  minWidth,
  MinWidthProps,
  maxWidth,
  MaxWidthProps,
  width,
  WidthProps,
  height,
  HeightProps,
  space,
  SpaceProps,
  textAlign,
  TextAlignProps,
} from 'styled-system';

export type BoxProps = StyledProps<any> &
  MinWidthProps &
  MaxWidthProps &
  WidthProps &
  HeightProps &
  SpaceProps &
  TextAlignProps;

export const Box = styled.div<BoxProps>`
  box-sizing: border-box;
  ${minWidth};
  ${maxWidth};
  ${width};
  ${height};
  ${textAlign};
  ${space};
`;

// // TODO @grsmto: remove when https://github.com/pedronauck/docz/issues/337 is resolved
export const BoxDocz = (props: BoxProps) => {
  return <Box {...props} />;
};
try {
    // @ts-ignore
    Box.displayName = "Box";
    // @ts-ignore
    Box.__docgenInfo = { "description": "", "displayName": "Box", "props": { "theme": { "defaultValue": null, "description": "", "name": "theme", "required": false, "type": { "name": "any" } }, "as": { "defaultValue": null, "description": "Typing Note: prefer using .withComponent for now as it is actually type-safe.\n\nString types need to be cast to themselves to become literal types (as={'a' as 'a'}).", "name": "as", "required": false, "type": { "name": "\"symbol\" | \"object\" | \"a\" | \"abbr\" | \"address\" | \"area\" | \"article\" | \"aside\" | \"audio\" | \"b\" | \"base\" | \"bdi\" | \"bdo\" | \"big\" | \"blockquote\" | \"body\" | \"br\" | \"button\" | \"canvas\" | ... 154 more ... | FunctionComponent<...>" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/Box/Box.tsx#Box"] = { docgenInfo: Box.__docgenInfo, name: "Box", path: "src/components/Box/Box.tsx#Box" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    BoxDocz.displayName = "BoxDocz";
    // @ts-ignore
    BoxDocz.__docgenInfo = { "description": "", "displayName": "BoxDocz", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/Box/Box.tsx#BoxDocz"] = { docgenInfo: BoxDocz.__docgenInfo, name: "BoxDocz", path: "src/components/Box/Box.tsx#BoxDocz" };
}
catch (__react_docgen_typescript_loader_error) { }